<dialog
  #dialog
  [attr.aria-label]="alt ? 'Image preview: ' + alt : 'Image preview'"
  (click)="onBackdropClick($event)"
  (close)="onDialogClose()"
  >
  <button type="button" (click)="close()" aria-label="Close" autofocus>
    <span aria-hidden="true">&#215;</span>
  </button>
  @if (src) {
    <img [src]="src" [alt]="alt">
  }
</dialog>
